import { apiHelper } from "../apiHelper/apiHelper";
import {
  getTenantsRequest,
  getTenantsSuccess,
  getTenantsFailure,
  getTenantRequest,
  getTenantSuccess,
  getTenantFailure,

  getTenantAdminsRequest,
  getTenantAdminsSuccess,
  getTenantAdminsFailure,

  getTenantManagersRequest,
  getTenantManagersSuccess,
  getTenantManagersFailure,
  
  getTenantFarmersRequest,
  getTenantFarmersSuccess,
  getTenantFarmersFailure,
  
  getTenantSuppliersRequest,
  getTenantSuppliersSuccess,
  getTenantSuppliersFailure,
  
  getTenantConsultantsRequest,
  getTenantConsultantsSuccess,
  getTenantConsultantsFailure,

  getTenantCropsRequest,
  getTenantCropsSuccess,
  getTenantCropsFailure,

  getTenantSchedualersRequest,
  getTenantSchedualersSuccess,
  getTenantSchedualersFailure,
} from "../slices/tenantSlices";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

// const BASE_URI = process.env.REACT_APP_BASE_URI;

export const handleGetTenantsData = async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = "tenants/";
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantsRequest;
  const state2 = getTenantsSuccess;
  const state3 = getTenantsFailure;
  const isToast = true;
  const isFile = false;
  const isToken = false;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch admin data.");
  }
};


export const handleGetTenantData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantRequest;
  const state2 = getTenantSuccess;
  const state3 = getTenantFailure;
  const isToast = true;
  const isFile = false;
  const isToken = false;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch super admin data.");
  }
};


export const handleGetTenantAdminsData  = (tenantid) => async (dispatch) => {
  const endPoint = `tenants/admins/${tenantid}`;
  const state1 = getTenantAdminsRequest;
  const state2 = getTenantAdminsSuccess;
  const state3 = getTenantAdminsFailure;
  dispatch(state1());
  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URI}/${endPoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("auth-token")}`,
      },
    });
    if (res.status === 404) {
      // No admins for this tenant - treat as empty result (no toast)
      dispatch(
        state2({
          data: { admins: [] },
          message: "No admins found",
          statusCode: 404,
        })
      );
      return { data: { admins: [] } };
    }
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      toast.error(data?.message || "Failed to fetch Admins data.");
      dispatch(state3());
      return false;
    }
    const data = await res.json();
    dispatch(state2(data));
    return data;
  } catch (err) {
    dispatch(state3());
    toast.error(err.message || "Failed to fetch Admins data.");
    return false;
  }
};


export const handleGetTenantManagersData  = (tenantid) => async (dispatch) => {
  const endPoint = `tenants/managers/${tenantid}`;
  const state1 = getTenantManagersRequest;
  const state2 = getTenantManagersSuccess;
  const state3 = getTenantManagersFailure;
  dispatch(state1());
  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URI}/${endPoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("auth-token")}`,
      },
    });
    if (res.status === 404) {
      // No managers for this tenant - treat as empty result (no toast)
      dispatch(
        state2({
          data: { managers: [] },
          message: "No managers found",
          statusCode: 404,
        })
      );
      return { data: { managers: [] } };
    }
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      toast.error(data?.message || "Failed to fetch Managers data.");
      dispatch(state3());
      return false;
    }
    const data = await res.json();
    dispatch(state2(data));
    return data;
  } catch (err) {
    dispatch(state3());
    toast.error(err.message || "Failed to fetch Managers data.");
    return false;
  }
};


export const handleGetTenantFarmersData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/farmers/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantFarmersRequest;
  const state2 = getTenantFarmersSuccess;
  const state3 = getTenantFarmersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch Farmers data.");
  }
};



export const handleGetTenantSuppliersData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/suppliers/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantSuppliersRequest;
  const state2 = getTenantSuppliersSuccess;
  const state3 = getTenantSuppliersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch Supplier data.");
  }
};



export const handleGetTenantConsultantsData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/consultants/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantConsultantsRequest;
  const state2 = getTenantConsultantsSuccess;
  const state3 = getTenantConsultantsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch Consultants data.");
  }
};

export const handleGetTenantCropsData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/crops/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantCropsRequest;
  const state2 = getTenantCropsSuccess;
  const state3 = getTenantCropsFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch Crops data.");
  }
};

export const handleGetTenantSchedualersData  = (tenantid) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `tenants/schedualers/${tenantid}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getTenantSchedualersRequest;
  const state2 = getTenantSchedualersSuccess;
  const state3 = getTenantSchedualersFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch Crops data.");
  }
};

